module.exports = __webpack_public_path__ + "img/23.1a2b56f9.svg";